import type { SVGProps } from "react";
export interface RulerTriangleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function RulerTriangleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: RulerTriangleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M5.383 14.206a1.126 1.126 0 0 1 1.59 0l1.998 2 .078.084a1.126 1.126 0 0 1-1.583 1.582l-.085-.076-1.998-1.998a1.127 1.127 0 0 1 0-1.592m10.822-.501a1.126 1.126 0 0 1 1.92.795V17c0 .621-.504 1.125-1.125 1.125h-2.5a1.126 1.126 0 0 1-.796-1.92zm-7.881-2.44a1.125 1.125 0 0 1 1.506-.077l.085.078 1.998 1.998.078.085a1.126 1.126 0 0 1-1.584 1.583l-.085-.078-1.998-1.997-.078-.087a1.124 1.124 0 0 1 .078-1.504Zm2.941-2.94a1.124 1.124 0 0 1 1.505-.078l.086.077 1.998 1.998.078.085a1.126 1.126 0 0 1-1.584 1.584l-.085-.078-1.998-1.998-.077-.085a1.125 1.125 0 0 1 .077-1.506Zm2.94-2.942c.44-.44 1.153-.44 1.593 0l1.998 1.998.076.085a1.125 1.125 0 0 1-1.582 1.583l-.085-.077-2-1.998a1.126 1.126 0 0 1 0-1.591"
      />
      <path
        fill={color}
        d="M19.875 5.008c0-.73-.828-1.118-1.386-.71l-.108.092L4.39 18.381c-.551.551-.161 1.494.618 1.494H18c1.035 0 1.875-.84 1.875-1.875zM22.125 18A4.125 4.125 0 0 1 18 22.125H5.008c-2.784 0-4.177-3.366-2.209-5.335L16.79 2.8l.19-.176c1.987-1.705 5.146-.312 5.146 2.384V18Z"
      />
    </svg>
  );
}
